import { findColor } from "@/constants/colors";

const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
const WH = { china: "CHINA", usa: "USA", canada: "CANADA" };

/** 4×6 in storage label for a set kept in stock: LEPRECON PLUS · Catalog # · colour (+中文 when zh).
 *  Cancelled sets print the PO # in the footer; ON HOLD sets print "ON HOLD" and the PO # very small (rule Jun 2026).
 *  Prints on the regular shipping-label printer; every line is auto-sized to the label width. */
export function printStopLabel({ po, cat, color, warehouse, lang, hold = false, stock = false }) {
  const c = findColor(color);
  const colorName = c ? c.name : (color || "—");
  const colorZh = lang === "zh" && c?.zh ? c.zh : "";
  const date = new Date().toLocaleDateString(lang === "zh" ? "zh-CN" : "en-CA");
  const foot = stock
    ? `<span style="font-weight:900;letter-spacing:.12em">STOCK</span><span>${esc(WH[warehouse] || String(warehouse || "").toUpperCase())}</span><span>${esc(date)}</span>`
    : hold
    ? `<span style="font-weight:900;letter-spacing:.12em">ON HOLD</span><span>${esc(WH[warehouse] || String(warehouse || "").toUpperCase())}</span><span>${esc(date)}</span><span style="font-size:6pt;font-weight:500;align-self:flex-end">${esc(po || "")}</span>`
    : `<span>${esc(po || "")}</span><span>${esc(WH[warehouse] || String(warehouse || "").toUpperCase())}</span><span>${esc(date)}</span>`;
  const unitLine = stock ? `<div class="fit cat" data-max="34" style="margin-bottom:.08in">${esc(po || "")}</div>` : "";
  const html = `<!doctype html><html><head><meta charset="utf-8"><title>${esc(cat || po)} label</title>
  <style>
    @page { size: 4in 6in; margin: 0; }
    html,body{margin:0;padding:0;width:4in;height:6in;overflow:hidden;background:#fff}
    body{font-family:-apple-system,"Segoe UI",Roboto,"Noto Sans SC","PingFang SC",sans-serif;color:#000;display:flex;flex-direction:column;box-sizing:border-box;padding:.16in .14in}
    .fit{white-space:nowrap;font-weight:900;line-height:1;text-align:center;width:100%;overflow:hidden}
    .brand{letter-spacing:.14em;border-bottom:4px solid #000;padding-bottom:.08in}
    .block{flex:1;display:flex;flex-direction:column;justify-content:center;align-items:center;width:100%}
    .lbl{font-size:11pt;font-weight:700;letter-spacing:.22em;text-transform:uppercase;margin-bottom:.06in}
    .cat{font-family:ui-monospace,Menlo,Consolas,"Courier New",monospace;letter-spacing:.04em}
    .foot{border-top:2px solid #000;padding-top:.06in;font-size:10pt;font-weight:700;display:flex;justify-content:space-between;gap:6pt}
    *{-webkit-print-color-adjust:exact;print-color-adjust:exact}
  </style></head><body>
  <div class="fit brand" data-max="30">LEPRECON PLUS</div>
  <div class="block"><div class="lbl">Catalog #</div><div class="fit cat" data-max="150">${esc(cat || "—")}</div></div>
  <div class="block"><div class="lbl">Colour</div><div class="fit" data-max="${colorZh ? 90 : 110}">${esc(colorName)}</div>${colorZh ? `<div class="fit" data-max="80" style="margin-top:.08in">${esc(colorZh)}</div>` : ""}</div>
  ${unitLine}
  <div class="foot">${foot}</div>
  <script>
    function fit(el){var s=parseFloat(el.getAttribute('data-max'))||100;var w=el.parentElement.clientWidth;el.style.fontSize=s+'pt';while(s>8&&el.scrollWidth>w){s-=2;el.style.fontSize=s+'pt';}}
    window.addEventListener('load',function(){document.querySelectorAll('.fit').forEach(fit);setTimeout(function(){window.focus();window.print();},250);});
  </script></body></html>`;
  const w = window.open("", "_blank", "width=480,height=760");
  if (!w) return false;
  w.document.open();
  w.document.write(html);
  w.document.close();
  return true;
}
